export const OPEN_POPUP_DELAY = 200;
export const CLOSE_POPUP_DELAY = 300;
